export const ACTION_START_SESSION = 'TWILIO_ACTION_START_SESSION';
export const ACTION_ADD_MULTIPLE_MESSAGES = 'TWILIO_ACTION_ADD_MULTIPLE_MESSAGES';
export const ACTION_ADD_MESSAGE = 'TWILIO_ACTION_ADD_MESSAGE';
export const ACTION_REMOVE_MESSAGE = 'TWILIO_ACTION_REMOVE_MESSAGE';
export const ACTION_UPDATE_MESSAGE = 'TWILIO_ACTION_UPDATE_MESSAGE';
export const ACTION_ATTACH_FILES = 'TWILIO_ACTION_ATTACH_FILES';
export const ACTION_DETACH_FILES = 'TWILIO_ACTION_DETACH_FILES';
export const ACTION_ADD_PARTICIPANT = 'TWILIO_ACTION_ADD_PARTICIPANT';
export const ACTION_REMOVE_PARTICIPANT = 'TWILIO_ACTION_REMOVE_PARTICIPANT';
export const ACTION_UPDATE_PARTICIPANT = 'TWILIO_ACTION_UPDATE_PARTICIPANT';
export const ACTION_UPDATE_CONVERSATION_STATE = 'TWILIO_ACTION_UPDATE_CONVERSATION_STATE';
export const ACTION_UPDATE_SESSION_DATA = 'TWILIO_ACTION_UPDATE_SESSION_DATA';
export const ACTION_ADD_PARTICIPANT_EVENT_MESSAGE = 'TWILIO_ACTION_ADD_PARTICIPANT_EVENT_MESSAGE';
export const ACTION_UPDATE_CONNECTION_STATE = 'TWILIO_ACTION_UPDATE_CONNECTION_STATE';
export const ACTION_SET_MESSAGES = 'TWILIO_ACTION_SET_MESSAGES';

